import * as React from 'react';
import * as ReactDOM from 'react-dom';

import KendoBaseComponent, { KendoWidgetProps } from '@progress/kendo-base-component-react-wrapper';

export interface TimePickerProps extends KendoWidgetProps, kendo.ui.TimePickerOptions {
    children?: React.ReactNode;
}

export default class TimePicker extends KendoBaseComponent<TimePickerProps, {}> {
    componentDidMount(): void {
        const domNode = this.domNode;
        const { children, widgetRef, ...props } = this.props;

        if (domNode) {
            this.widgetInstance = new kendo.ui.TimePicker(domNode as Element, (props as kendo.ui.TimePickerOptions));
            super.componentDidMount();
        }
    }

    render(): any {
        if (this.didMount) {
            const { children, widgetRef, ...props } = this.props;

            this.widgetInstance.setOptions(props);
            (this.widgetInstance as kendo.ui.TimePicker).value(props.value as Date);
        }

        const domChild = React.Children
            .toArray(this.props.children)
            .filter((child: React.ReactElement<any>) => child && (child.type === 'input'))
            .shift();

        return domChild
            ? React.cloneElement(domChild, { ...domChild.props, ref: this.elementRef })
            : <input ref={this.elementRef} />;
    }
}



// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-react-wrapper/src/timepicker/index.tsx